import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogTitle as MuiDialogTitle,
  type DialogActionsProps as MuiDialogActionsProps,
  type DialogContentProps as MuiDialogContentProps,
  type DialogContentTextProps as MuiDialogContentTextProps,
  type DialogProps as MuiDialogProps,
  type DialogTitleProps as MuiDialogTitleProps,
} from '@mui/material'

export type DialogProps = MuiDialogProps
export type DialogTitleProps = MuiDialogTitleProps
export type DialogContentProps = MuiDialogContentProps
export type DialogContentTextProps = MuiDialogContentTextProps
export type DialogActionsProps = MuiDialogActionsProps

export const Dialog = MuiDialog
export const DialogTitle = MuiDialogTitle
export const DialogContent = MuiDialogContent
export const DialogContentText = MuiDialogContentText
export const DialogActions = MuiDialogActions
